import { conversationPath } from './navigation.js';

// Route through the application's existing hash navigation guard. A notification
// must not reload a page, discard an unsaved reply or bypass staff authentication.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', event => {
    const data = event.data;
    if (!navigator.serviceWorker.controller || event.source !== navigator.serviceWorker.controller ||
        window.location.pathname !== '/studentplayground/inbox/' || window.location.search ||
        data?.type !== 'tutory:inbox-notification' || data.version !== 1 || typeof data.path !== 'string') return;
    const path = data.path === '/inbox' ? '/inbox'
      : data.path.startsWith('/inbox/') && conversationPath(data.path.slice('/inbox/'.length));
    if (path && path === data.path) window.location.hash = '#' + path;
  });
}
